<mat-dialog-content>
  <h2 class="dialog-title-no-padding" mat-dialog-title>Confirm changes</h2>

  <ul class="list-padding-left">
    <li *ngFor="let change of changes" class="list-item-margin">{{ change }}</li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="confirm()">Save</button>
</mat-dialog-actions>
